import React, { useState, useEffect } from 'react'

import { debounceFunction } from 'utilities/helpers'
import { MarkSegmentsConfirmButton, MarkTextConfirmButton, SegmentsBackground } from './Selection'
import { classes } from '..'
import { locationHandler } from '../selection'

import useSelection from './useSelection'

const noRange = { parent: null, range: [] }

const SelectionControls = React.memo(() => {
  const { text } = useSelection()
  const [segments, setSegments] = useState(noRange)
  // const [textx, setText] = useState(noRange)

  const [mouseDown, setMouseDown] = useState(false)

  useEffect(() => {
    const editor = document.getElementsByClassName(classes.wrapper)[0]
    if (!editor) return
    editor.dataset.selectingMultiple = segments.parent && !text?.parent
    return () => (editor.dataset.selectingMultiple = !segments.parent || text?.parent)
  }, [segments, text])

  useEffect(() => {
    let timeout = null
    const debounced = debounceFunction(() => locationHandler(setSegments, () => {}, noRange))
    const eventHandler = () => (timeout = debounced())
    document.addEventListener('selectionchange', eventHandler)
    return () => {
      clearTimeout(timeout)
      document.removeEventListener('selectionchange', eventHandler)
    }
  }, [setSegments])

  useEffect(() => {
    const handleMouseDown = event => {
      const targetClassListArray = Array.from(event.target?.classList ?? [])
      if (
        targetClassListArray.includes(classes.selectionControls.segments.button) ||
        targetClassListArray.includes(classes.selectionControls.text.button)
      )
        return
      setMouseDown(true)
    }
    const handleMouseUp = () => setMouseDown(false)
    window.addEventListener('mousedown', handleMouseDown, { capture: true })
    window.addEventListener('mouseup', handleMouseUp, { capture: true })
  }, [])

  useEffect(() => {
    if (mouseDown) {
      const styleElement = document.createElement('style')
      styleElement.dataset.sheet = 'Wizard-Editor-SelectionControls-Style-Sheet'
      styleElement.setAttribute('type', 'text/css')
      styleElement.innerHTML = `.${classes.selectionControls.text.wrapper} { pointer-events: none; }\n.${classes.selectionControls.segments.wrapper} { pointer-events: none; }`
      document.head.appendChild(styleElement)
      return () => document.head.removeChild(styleElement)
    }
  }, [mouseDown])

  return (
    <>
      {segments.parent ? (
        <>
          <SegmentsBackground segments={segments} />
          <MarkSegmentsConfirmButton segments={segments} />
        </>
      ) : null}
      {text?.parent ? <MarkTextConfirmButton text={text} /> : null}
    </>
  )
})

SelectionControls.displayName = 'Wizard-Editor-SelectionControls'

export default SelectionControls
